import { MusicCircleOutlineIcon } from './MusicCircleOutlineIcon';

/**
 * author: Austin Andrews
 * id C8E3DFB3-2F22-489D-90F5-D8C47B66DB3C
 * name music-circle-outline
 * version: 2.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/music-circle-outline.svg
 * tags
 * - Music 
 * - Audio 
 */
export const NoteCircleOutlineIcon = MusicCircleOutlineIcon;
export default NoteCircleOutlineIcon